export default __webpack_public_path__ + "static/media/ic_chat.713f8061.svg";